module.exports = __webpack_public_path__ + "img/D8.f40cb1cb.svg";